/**
 * Opens a passed link in a new tab.
 *
 * @param url The url to open in a new tab.
 */

export default function openNewTab( url = '' ) {
	const link = document.createElement( 'a' );
	link.href = url;
	link.target = '_blank';
	document.body.appendChild( link );
	link.click();
	link.remove();
}
